module.exports = __webpack_public_path__ + "static/img/cabinet24_22.f4631794.gif";